import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import CreateAccountForm from "./CreateAccountForm";
import UserTable from "./UserTable";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../Login/firebase";
import {
  getAllUserSubAccountByUserId,
  getUserAccountByEmail,
} from "../../utils/data";

export default function UsersPage() {
  const [user] = useAuthState(auth);

  const [userId, setUserId] = useState("");
  const [userSubAccountsData, setUserSubAccountsData] = useState([]);

  useEffect(() => {
    const fetchUserData = async () => {
      const email = user && user.email;

      const userAccountData = await getUserAccountByEmail(email);

      const id = userAccountData?.data[0]?.id
        ? userAccountData?.data[0]?.id
        : "";
      setUserId(id);

      const subAccounts = await getAllUserSubAccountByUserId(id);

      setUserSubAccountsData(subAccounts?.data);
    };

    fetchUserData();
  }, [user]);

  return (
    <DashboardLayout>
      <div className="flex flex-col relative  w-full max-h-screen">
        <div className="flex md:absolute md:top-2 md:right-4">
          <CreateAccountForm
            userId={userId}
            userSubAccounts={userSubAccountsData}
          />
        </div>

        {userSubAccountsData.length === 0 ? (
          <div className="flex flex-col flex-1 items-center justify-center text-white">
            No Sub Accounts Found!!
          </div>
        ) : (
          <div className="flex flex-col flex-1 ">
            {userSubAccountsData.length > 0 && (
              <UserTable
                userId={userId}
                userSubAccounts={userSubAccountsData}
              />
            )}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
